import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import './SplashScreen.css';

// Original DIVI identity and approved timing; small initial word grows before the final reveal.

const letters=[{"name": "D", "width": 112, "path": "M0 0H55C90 0 112 21 112 50S90 100 55 100H0ZM20 20V80H54C78 80 92 69 92 50S78 20 54 20Z"}, {"name": "I", "width": 20, "path": "M0 0H20V100H0Z"}, {"name": "V", "width": 122, "path": "M0 0H25L61 72L97 0H122L71 100H51Z"}, {"name": "I", "width": 20, "path": "M0 0H20V100H0Z"}];
const symbolSource='data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMDAgMjAwIiBmaWxsPSJub25lIiBhcmlhLWhpZGRlbj0idHJ1ZSI+CiAgICAgIDxwYXRoIGQ9Ik0yNyA4OUE3NCA3NCAwIDAgMSAxMDAgMjciIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMTIiIC8+CiAgICAgIDxwYXRoIGQ9Ik0yNiAxMDJBNzQgNzQgMCAwIDAgOTYgMTc0TTEwOCAxNzRBNzQgNzQgMCAwIDAgMTY4IDg1IiBzdHJva2U9IiMxNjg4ZmYiIHN0cm9rZS13aWR0aD0iMTIiIC8+CiAgICAgIDxwYXRoIGQ9Ik00MyAxMTFMMTI5IDY1TDgyIDExNFoiIGZpbGw9IndoaXRlIiAvPgogICAgICA8cGF0aCBkPSJNODIgMTE0TDEyOSA2NUw5MyAxNTZaIiBmaWxsPSIjMTY4OGZmIiAvPgogICAgICA8Y2lyY2xlIGN4PSIxNDUiIGN5PSI1NSIgcj0iMTAiIGZpbGw9IiMxNjg4ZmYiIC8+CiAgICAgIDxnIGNsYXNzPSJkaXZpLXJhZGlvIiBzdHJva2U9IiMxNjg4ZmYiIHN0cm9rZS13aWR0aD0iNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIj4KICAgICAgICA8cGF0aCBkPSJNMTMwIDI5QTQzIDQzIDAgMCAxIDE3MyA2MiIgLz4KICAgICAgICA8cGF0aCBkPSJNMTMwIDEzQTU5IDU5IDAgMCAxIDE4OCA1OCIgLz4KICAgICAgPC9nPgo8L3N2Zz4=';

export function DiviSymbol() {
  return (
    <svg viewBox="0 0 200 200" fill="none" aria-hidden="true">
      <path d="M27 89A74 74 0 0 1 100 27" stroke="white" strokeWidth="12" />
      <path d="M26 102A74 74 0 0 0 96 174M108 174A74 74 0 0 0 168 85" stroke="currentColor" strokeWidth="12" />
      <path d="M43 111L129 65L82 114Z" fill="white" />
      <path d="M82 114L129 65L93 156Z" fill="currentColor" />
      <circle cx="145" cy="55" r="10" fill="currentColor" />
      <g className="divi-radio" stroke="currentColor" strokeWidth="5" strokeLinecap="round">
        <path d="M130 29A43 43 0 0 1 173 62" />
        <path d="M130 13A59 59 0 0 1 188 58" />
      </g>
    </svg>
  );
}


export default function SplashScreen({ ready = false, onComplete }) {
  const canvasRef = useRef(null);
  const completeRef = useRef(onComplete);
  const [introDone, setIntroDone] = useState(false);
  const [leaving, setLeaving] = useState(false);
  const [slow, setSlow] = useState(false);
  useEffect(() => { completeRef.current = onComplete; }, [onComplete]);
  useLayoutEffect(() => {
    const root = document.getElementById('root');
    const previousInert = root?.inert;
    document.body.classList.add('divi-splash-active');
    if (root) root.inert = true;
    return () => {
      document.body.classList.remove('divi-splash-active');
      if (root) root.inert = previousInert;
    };
  }, []);

  useLayoutEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas?.getContext('2d');
    if (!ctx || typeof Path2D === 'undefined') {
      setIntroDone(true);
      return undefined;
    }
    const paths = letters.map(letter => new Path2D(letter.path));
    const symbolImage = new Image();
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const start = performance.now() + (reduced ? 0 : 300);
    let raf = 0;
   let current = reduced ? 1.45 : -0.30;
const clamp=v=>Math.max(0,Math.min(1,v)),ease=v=>1-Math.pow(1-clamp(v),3);
function word(x,y,h,a){let w=274*h/100+15,offset=-w/2;ctx.save();ctx.globalAlpha=a;for(let i=0;i<4;i++){ctx.save();ctx.translate(x+offset,y-h/2);ctx.scale(h/100,h/100);
  
  ctx.fillStyle=i<2?'#fff':'#1688ff';ctx.fill(paths[i],'evenodd');ctx.restore();offset+=letters[i].width*h/100+5;}ctx.restore();}
function frame(t){let {width:w,height:h}=canvas.getBoundingClientRect(),d=Math.min(3,window.devicePixelRatio||1);const cw=Math.round(w*d),ch=Math.round(h*d);if(canvas.width!==cw||canvas.height!==ch){canvas.width=cw;canvas.height=ch;}ctx.setTransform(d,0,0,d,0,0);ctx.fillStyle='#030b1d';

ctx.fillRect(0,0,w,h);if(t<0)return;ctx.translate(w/2,h/2);

let s=Math.min(1,w/390);ctx.scale(s,s);
if(t<.82){let charge=clamp((t-.16)/.54),a=1-clamp((t-.70)/.12),j=Math.sin(t*105)*2*charge;let g=ctx.createRadialGradient(j,0,4,j,0,110);g.addColorStop(0,`rgba(22,136,255,${.24*charge})`);g.addColorStop(1,'rgba(22,136,255,0)');

ctx.fillStyle=g;
ctx.fillRect(-140,-140,280,280);ctx.save();ctx.translate(j,Math.cos(t*92)*charge);ctx.scale(1+.28*charge,1+.28*charge);ctx.shadowColor='#1688ff';ctx.shadowBlur=22*charge;word(0,0,28,a);ctx.restore();}
let out=1;if(t>=.79){let height=38,width=274*.38+15,left=-(width+14+48)/2,offset=0;for(let i=0;i<4;i++){let q=ease((t-.79-i*.045)/.30);if(!q)continue;ctx.save();ctx.globalAlpha=q*out;ctx.translate(left+offset+240*(1-q),-height/2);ctx.scale(.38,.38);ctx.fillStyle=i<2?'white':'#1688ff';ctx.fill(paths[i],'evenodd');ctx.restore();offset+=letters[i].width*.38+5;}let q=ease((t-.99)/.30);ctx.save();ctx.globalAlpha=q*out;ctx.translate(left+width+14+24,0);ctx.rotate((1-q)*-.25);ctx.scale(.75+.25*q,.75+.25*q);if(symbolImage.complete && symbolImage.naturalWidth) ctx.drawImage(symbolImage,-24,-24,48,48);ctx.restore();}}

    const redraw = () => frame(current);
    const tick = now => {
      current = reduced ? 1.45 : Math.min((now - start) / 1500, 1.65);
      frame(current);
      if (reduced || current >= 1.65) {
        setIntroDone(true);
      } else raf = requestAnimationFrame(tick);
    };
    symbolImage.onload = redraw;
    symbolImage.onerror = () => {
      // Retain the original mark if inline SVG decoding is blocked.
      symbolImage.onerror = null;
      symbolImage.src = '/icons/divi-icon-512-v1.png';
    };
    symbolImage.src = symbolSource;
    frame(current);
    raf = requestAnimationFrame(tick);
    window.addEventListener('resize', redraw);
    return () => {
      cancelAnimationFrame(raf);
      symbolImage.onload = null;
      symbolImage.onerror = null;
      window.removeEventListener('resize', redraw);
    };
  }, []);

  useEffect(() => {
    const notice = setTimeout(() => setSlow(true), 12000);
    return () => clearTimeout(notice);
  }, []);
  useEffect(() => {
    if (ready && introDone) setLeaving(true);
  }, [ready, introDone]);
  useEffect(() => {
    if (!leaving) return undefined;
    document.body.classList.remove('divi-splash-active');
    const timer = setTimeout(() => completeRef.current?.(), 250);
    return () => clearTimeout(timer);
  }, [leaving]);

  return createPortal(
    <div className={`splash-screen divi-splash${leaving ? ' divi-leaving' : ''}`}
      role="status" aria-label="Abriendo DIVI" aria-busy={!ready}>
      <canvas ref={canvasRef} className="divi-energy-canvas" aria-hidden="true" />
      {slow && !ready && !leaving && (
        <div className="divi-slow">
          <p>La conexión está tardando.</p>
          <button type="button" onClick={() => window.location.reload()}>Reintentar</button>
          <button type="button" onClick={() => setLeaving(true)}>Abrir aplicación</button>
        </div>
      )}
    </div>, document.body
  );
}
